export enum SupplierType{
    Agent='Agent',
    Farmer='Farmer',
    Dealer='Dealer'

}